import { render, staticRenderFns } from "./DialogYesNo.vue?vue&type=template&id=04b466c0"
import script from "./DialogYesNo.vue?vue&type=script&lang=js"
export * from "./DialogYesNo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04b466c0')) {
      api.createRecord('04b466c0', component.options)
    } else {
      api.reload('04b466c0', component.options)
    }
    module.hot.accept("./DialogYesNo.vue?vue&type=template&id=04b466c0", function () {
      api.rerender('04b466c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogYesNo.vue"
export default component.exports